import { useState } from "react";
import { breakClips } from "../../data/hobbies";
import "./BreakPanel.css";

export default function BreakPanel() {
	const [openCard, setOpenCard] = useState(null);
	const toggle = (id) => setOpenCard((prev) => (prev === id ? null : id));

	return (
		<div className="bp-bento" data-count={breakClips.length}>
			{breakClips.map((clip) => {
				const isOpen = openCard === clip.id;
				return (
					<button
						key={clip.id}
						className={`bp-card${isOpen ? " bp-card--open" : ""}`}
						onClick={() => toggle(clip.id)}
						aria-expanded={isOpen}
						aria-label={
							isOpen
								? `Close ${clip.caption}`
								: `${clip.caption} — tap for details`
						}
					>
						<div className="bp-card__photo">
							{clip.src ? (
								<img
									src={clip.src}
									alt={clip.caption}
									draggable="false"
								/>
							) : (
								<div
									className="bp-card__placeholder"
									aria-hidden="true"
								/>
							)}
						</div>

						<div className="bp-card__strip">
							<span className="bp-card__caption mono">
								{clip.caption}
							</span>
							<span className="bp-card__year mono">{clip.year}</span>
						</div>

						<div className="bp-card__overlay" aria-hidden={!isOpen}>
							<span className="bp-overlay__close mono" aria-hidden="true">
								✕
							</span>
							<p className="bp-overlay__context">{clip.context}</p>
							<div className="bp-overlay__meta">
								<span className="bp-overlay__location mono">
									◎ {clip.location}
								</span>
								<span className="bp-overlay__date mono">
									{clip.date}
								</span>
							</div>
						</div>
					</button>
				);
			})}
		</div>
	);
}
